<script>
import TextInput from '@/components/form/Inputs/TextInput'
import CheckboxInput from '@/components/form/Inputs/CheckboxInput'
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput'
import TextareaInput from '@/components/form/Inputs/TextareaInput'

import FormTabMixin from '@/components/mixins/FormTabMixin'

import SelectApiClientType from '@/api/SelectApiClientType'
import RestApiCollection from '@/api/RestApiCollection'
import RestApiType from '@/api/RestApiType'
import FormInput from '@/components/mixins/FormInput'

import mealType from '@/store/type/mealType'
import { mapGetters } from 'vuex'
import authType from '@/store/type/authType'

export default {
    components: {
        TextInput,
        CheckboxInput,
        TextareaInput,
        EntitySelectInput,
    },

    mixins: [FormTabMixin, FormInput],

    data() {
        return {
            model: {},
            selectApiClientType: SelectApiClientType,
            api: RestApiType.MEAL_OPTION,
        }
    },

    computed: {
        ...mapGetters({
            isRestaurantAdmin: authType.getters.IS_RESTAURANT_ADMIN,
            isSuperAdmin: authType.getters.IS_SUPER_ADMIN,
        }),
    },

    methods: {
        save() {
            if (!this.model.name) return
            if (this.model?.discountPrice === '')
                this.model.discountPrice = null

            if (this.model.id) {
                RestApiCollection.get(this.api)
                    .update(this.model, this.model.id)
                    .then(() => {
                        this.$emit('saved')
                    })
            } else {
                RestApiCollection.get(this.api)
                    .create(this.model)
                    .then((res) => {
                        this.$emit('saved')
                        this.$store.dispatch(mealType.actions.MEAL_OPTION, res)
                    })
            }
        },

        deleteOption() {
            this.$emit('deleteOption', this.model.id)
        },

        cancel() {
            this.$emit('cancel')
        },
    },
}
</script>

<template>
    <div class="meal-option-form">
        <form @submit.prevent="save">
            <text-input
                v-model="model.name"
                v-tab-error:mealOptionGroups
                v-validate.immediate="'required|space'"
                name="name"
                label="labels.name"
                :error-messages="errors.collect('name')"
                :data-vv-as="$t('labels.name')"
            ></text-input>
            <text-input
                v-model="model.price"
                v-tab-error:mealOptionGroups
                v-validate="'required'"
                name="price"
                label="labels.price"
                :error-messages="errors.collect('price')"
                :data-vv-as="$t('labels.price')"
            ></text-input>
            <text-input
                v-if="isSuperAdmin"
                v-model="model.discountPrice"
                v-tab-error:mealOptionGroups
                name="discountPrice"
                label="labels.discountPrice"
                :error-messages="errors.collect('discountPrice')"
                :data-vv-as="$t('labels.discountPrice')"
            ></text-input>
            <textarea-input
                v-model="model.description"
                v-validate="'space'"
                v-tab-error:mealOptionGroups
                name="description"
                label="labels.description"
                :error-messages="errors.collect('description')"
                :data-vv-as="$t('labels.description')"
            ></textarea-input>
            <text-input
                v-if="!isRestaurantAdmin"
                v-model="model.code"
                v-tab-error:mealOptionGroups
                v-validate="'space'"
                name="code"
                label="labels.code"
                :error-messages="errors.collect('code')"
                :data-vv-as="$t('labels.code')"
            ></text-input>
            <text-input
                v-if="!isRestaurantAdmin"
                v-model.number="model.deliveryUnit"
                v-tab-error:mealOptionGroups
                v-validate.immediate="'required|numeric|min_value:0'"
                name="deliveryUnit"
                label="labels.delivery_unit"
                :error-messages="errors.collect('deliveryUnit')"
                :data-vv-as="$t('labels.delivery_unit')"
            ></text-input>
            <checkbox-input
                v-model="model.isActive"
                label="labels.active"
                name="isActive"
            ></checkbox-input>

            <entity-select-input
                v-model="model.valueAddedTax"
                v-tab-error:mealOptionGroups
                v-validate.immediate="'required'"
                label="labels.vat"
                name="valueAddedTax"
                :entity="selectApiClientType.VAT"
                :data-vv-as="$t('labels.vat')"
                :error-messages="errors.collect('valueAddedTax')"
            ></entity-select-input>
            <div class="d-flex justify-end px-4 pt-4">
                <div>
                    <v-btn
                        v-if="model.id && !isRestaurantAdmin"
                        class="mr-4"
                        color="warning"
                        @click="deleteOption"
                    >
                        {{ $t('actions.delete') }}
                    </v-btn>
                    <v-btn
                        v-else
                        variant="secondary"
                        class="mr-3"
                        @click="cancel"
                    >
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn
                        color="success"
                        :disabled="!model.name"
                        type="submit"
                    >
                        {{ $t('actions.save') }}
                    </v-btn>
                </div>
            </div>
        </form>
    </div>
</template>
